import EnterpriseApiService from "src/api/EnterpriseApiService";
import { queryOptions } from "./v4QueryOptions/queryOptions"

export const getUnusedAzureIotDevicesOptions = () => {
    return queryOptions({
        queryKey: ["getUnusedAzureIoTDevicesQuery"],
        retry: false,
        enabled: true,
        refetchOnWindowFocus: false,
        queryFn: async (q) => {

            return await EnterpriseApiService.getUnusedDevicesForBin(q.signal);
        }
    });
}